const transformer = function (origin, defs, rowData, fields, hooks) {
  // let selected = []

  // if (hooks && hooks.tbDataControl) {
  //   selected = hooks.tbDataControl('get-selected')
  // }

  // const value = selected.indexOf(rowData.objectId) > -1
  // console.log(rowData, origin)
  // const value = !!(
  //   selected.indexOf(rowData.objectId) > -1 || rowData.__selection__
  // )
  const value = !!rowData.__selection__

  return {
    render: 'boolean',
    origin,
    value,
    rowData,
    hooks,
    size: 'sm',
    defs,
    onChange(val) {
      if (hooks && hooks.toggleCheck) {
        hooks.toggleCheck(rowData.objectId, val)
        // hooks.tbDataControl('toggle-select', {
        //   ids: rowData.objectId,
        //   select: val,
        // })
      }
    },
  }
}

export default transformer
